/**
 * Design system source of truth.
 *
 * Color tokens:
 * - primary  : bronco palette (warm tan, defined in app/styles/tailwind.css)
 * - neutral  : stone (warm grayscale, complements bronco)
 * - semantic : success/error/warning/info default to Tailwind green/red/yellow/blue
 *
 * Component defaults are set here so call sites stay free of size/color props.
 * Overrides at the call site are still allowed.
 */
export default defineAppConfig({
  ui: {
    colors: {
      primary: 'bronco',
      neutral: 'stone',
    },
    button: {
      defaultVariants: {
        size: 'md',
        color: 'primary',
      },
    },
    input: {
      defaultVariants: {
        size: 'md',
      },
    },
  },
})
